import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { issueReconciliationProductTargetsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/qa-operations-core/issue-reconciliation/product-targets/')({
  validateSearch: zodValidator(issueReconciliationProductTargetsSearchSchema)
});